module.exports = __webpack_public_path__ + "img/br.23c03a16.svg";